"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Enum class TouchpointCategory.
* @enum {}
* @readonly
*/
var TouchpointCategory = /*#__PURE__*/function () {
  function TouchpointCategory() {
    _classCallCheck(this, TouchpointCategory);

    _defineProperty(this, "CALL", "CALL");

    _defineProperty(this, "IN-PERSON", "IN-PERSON");

    _defineProperty(this, "EMAIL", "EMAIL");

    _defineProperty(this, "SOCIAL MEDIA", "SOCIAL MEDIA");

    _defineProperty(this, "COURT HEARING", "COURT HEARING");

    _defineProperty(this, "MEETUP", "MEETUP");

    _defineProperty(this, "SUPPORT MEETING", "SUPPORT MEETING");

    _defineProperty(this, "LAW ENFORCEMENT", "LAW ENFORCEMENT");

    _defineProperty(this, "VIRTUAL", "VIRTUAL");

    _defineProperty(this, "SOCIAL POST (VICTIM)", "SOCIAL POST (VICTIM)");

    _defineProperty(this, "DISCUSSED ON PODCAST (VICTIM)", "DISCUSSED ON PODCAST (VICTIM)");

    _defineProperty(this, "FEATURED IN NEWSLETTER (VICTIM)", "FEATURED IN NEWSLETTER (VICTIM)");

    _defineProperty(this, "DISCUSSED ON TV / INTERVIEW (VICTIM)", "DISCUSSED ON TV / INTERVIEW (VICTIM)");

    _defineProperty(this, "NEWS ARTICLE", "NEWS ARTICLE");

    _defineProperty(this, "BLOG POST", "BLOG POST");

    _defineProperty(this, "OTHER", "OTHER");
  }

  _createClass(TouchpointCategory, null, [{
    key: "constructFromObject",

    /**
    * Returns a <code>TouchpointCategory</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/TouchpointCategory} The enum <code>TouchpointCategory</code> value.
    */
    value: function constructFromObject(object) {
      return object;
    }
  }]);

  return TouchpointCategory;
}();

exports.default = TouchpointCategory;